module.exports = __webpack_public_path__ + "static/media/_DS_Store.194577a7.bin";